import moment from 'moment-timezone';

const timezones = moment.tz.names();

export default timezones;
